import { render, staticRenderFns } from "./AccessruleDetails.vue?vue&type=template&id=e74964c0&scoped=true&"
import script from "./AccessruleDetails.vue?vue&type=script&lang=js&"
export * from "./AccessruleDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccessruleDetails.vue?vue&type=style&index=0&id=e74964c0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74964c0",
  null
  
)

export default component.exports